import capitalize from "utils/capitalize";

const capitalizeAll = (str: string) => {
  return str
    ?.split(" ")
    ?.map((subStr) => capitalize(subStr))
    .join(" ");
};

export default capitalizeAll;
